<app-toolbar [(sidenavToggle)]="sidenavState"></app-toolbar>

@if (user(); as user) {
    <mat-sidenav-container class="hydra-container" autosize>
        <mat-sidenav
            #sidenav
            class="hydra-sidenav"
            [mode]="mode"
            [(opened)]="sidenavState"
        >
            <mat-nav-list class="rm-scrollbar">
                @for (item of menu(user); track item) {
                    <app-menu-list-item [item]="item"></app-menu-list-item>
                }
            </mat-nav-list>
        </mat-sidenav>
        <mat-sidenav-content class="hydra-sidenav-content">
            <router-outlet></router-outlet>
        </mat-sidenav-content>
    </mat-sidenav-container>
}
